export const GET_REFER_FRIEND_FEATURE = "GET_REFER_FRIEND_FEATURE"
export const GET_REFER_FRIEND_FEATURE_SUCCESS =
  "GET_REFER_FRIEND_FEATURE_SUCCESS"
export const GET_REFER_FRIEND_FEATURE_FAILED = "GET_REFER_FRIEND_FEATURE_FAILED"
export const RESET_REFER_FRIEND_FEATURE_FORM = "RESET_REFER_FRIEND_FEATURE_FORM"

export const UPDATE_REFER_FRIEND_FEATURE = "UPDATE_REFER_FRIEND_FEATURE"
export const UPDATE_REFER_FRIEND_FEATURE_SUCCESS =
  "UPDATE_REFER_FRIEND_FEATURE_SUCCESS"
export const UPDATE_REFER_FRIEND_FEATURE_FAILED =
  "UPDATE_REFER_FRIEND_FEATURE_FAILED"

export const GET_REFER_FRIEND_REPORTS = "GET_REFER_FRIEND_REPORTS"
export const GET_REFER_FRIEND_REPORTS_SUCCESS =
  "GET_REFER_FRIEND_REPORTS_SUCCESS"
export const GET_REFER_FRIEND_REPORTS_FAILED = "GET_REFER_FRIEND_REPORTS_FAILED"
export const RESET_REFER_FRIEND_REPORTS = "RESET_REFER_FRIEND_REPORTS"
